import { GraphiQL } from 'graphiql';
import 'graphiql/graphiql.css';
import axios from 'axios';
import { getProjectId } from '@appmaker/core/store/project';
import { APPMAKER_GQL_URL } from '@appmaker/core/api/core';

const fetcher = async (graphQLParams) => {
	const projectId = getProjectId();
	try {
		const response = await axios.post(
			APPMAKER_GQL_URL,
			JSON.stringify(graphQLParams),
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
                    'x-appmaker-project-id': projectId,
				},
				credentials: 'include',
				withCredentials: true,
			}
		);
		return response.data;
	} catch (error) {}
	return null;
};
const GraphqlExplorer = () => {
	return (
		<div className="h-full">
			<GraphiQL fetcher={fetcher} />
		</div>
	);
};

export default GraphqlExplorer;
